import { render, staticRenderFns } from "./Unlink.vue?vue&type=template&id=589df7ca&scoped=true&"
import script from "./Unlink.vue?vue&type=script&lang=js&"
export * from "./Unlink.vue?vue&type=script&lang=js&"
import style0 from "./Unlink.vue?vue&type=style&index=0&id=589df7ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589df7ca",
  null
  
)

export default component.exports